/**
 * A questionnaire can be reopened once the client has submitted it — that is
 * the only state in which the fill view locks and the public save/submit
 * endpoints reject. Shared so the backend guard and every producer control
 * that offers "Reopen" agree on when the action applies.
 */
export function isReopenableStatus(status) {
    return status === 'SUBMITTED' || status === 'REVIEWED';
}
/** Reopen applies to submitted event questionnaires — never to templates. */
export function canReopenQuestionnaire(questionnaire) {
    return !questionnaire.isTemplate && isReopenableStatus(questionnaire.status);
}
//# sourceMappingURL=questionnaire.js.map